import { Logo } from '@THC/components/Logo';

import { AccountMenu } from '../AccountMenu';

import styles from './Header.module.scss';

export const Header = () => {
	return (
		<header className={styles.container} data-test="header-wrapper">
			<div className={styles.header}>
				<div className={styles.logo}>
					<Logo />
				</div>
				<div className={styles.accountMenu}>
					<AccountMenu />
				</div>
			</div>
		</header>
	);
};
